import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BasefieldV2Component } from '@app/formly/types/v2/basefield-v2/basefield-v2.component';

@Component({
  selector: 'free-text-field',
  templateUrl: './free-text-field.component.html',
  styleUrls: ['./free-text-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreeTextFieldComponent extends BasefieldV2Component implements OnInit {
  innerModel = new FormControl('');

  ngOnInit() {
    if (this.formControl.value) {
      this.innerModel.setValue(this.formControl.value as string);
    }
  }

  search() {
    this.formControl.setValue(this.innerModel.value);
  }
}
